import { render, staticRenderFns } from "./MixGameArticles.vue?vue&type=template&id=16592d74&scoped=true"
import script from "./MixGameArticles.vue?vue&type=script&lang=ts"
export * from "./MixGameArticles.vue?vue&type=script&lang=ts"
import style0 from "./MixGameArticles.vue?vue&type=style&index=0&id=16592d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16592d74",
  null
  
)

export default component.exports